// 用户模块 API
// src/api/user.js
import request from '@/utils/request'

// 获取用户信息
export const getUserProfile = () => {
  return request({
    method: 'get',
    url: '/user'
  })
}

// 刷新用户信息
export const refreshUserInfo = () => {
  return request({
    method: 'get',
    url: '/user/refreshUserInfo'
  })
}

// 获取用户帖子
export const getUserPost = () => {
  return request({
    method: 'get',
    url: '/user/getPost'
  })
}

// 获取用户评论
export const getUserRemark = (isAudit) => {
  return request({
    method: 'get',
    url: '/user/getRemark',
    params: { isAudit }
  })
}

// 获取用户收藏帖子
export const getUserCollect = (lotteryId) => {
  return request({
    method: 'get',
    url: '/user/collect',
    params: { lotteryId }
  })
}

// 获取用户点赞帖子
export const getUserLike = (lotteryId) => {
  return request({
    method: 'get',
    url: '/user/like',
    params: { lotteryId }
  })
}

// 获取用户账户明细
export const getAccount = () => {
  return request({
    method: 'get',
    url: '/user/account'
  })
}

// 获取用户下级
export const getChildren = () => {
  return request({
    method: 'get',
    url: '/user/children'
  })
}

// 查询下级数据
export const getChildDetail = (id) => {
  return request({
    method: 'get',
    url: '/user/childDetail',
    params: { id }
  })
}

// 关注列表
export const getFollow = (data) => {
  return request({
    method: 'get',
    url: '/user/follow',
    params: data
  })
}

// 更新用户信息
export const updateUserProfile = (data) => {
  return request({
    method: 'put',
    url: '/user',
    params: data
  })
}

// 更新用户密码
export const updateSecurity = (data) => {
  return request({
    method: 'put',
    url: '/user/updateSecurity',
    data: data
  })
}

// 修改密码
export const changePassword = (oldPwd, newPwd) => {
  return request({
    method: 'patch',
    url: '/user/password',
    data: { oldPwd, newPwd }
  })
}

// 更新下级返点
export const updateChildRebate = (data) => {
  console.log('data===', data)
  return request({
    method: 'put',
    url: '/user/updateChildRebate',
    data: data
  })
}

// 上传头像（FormData）
export const uploadAvatar = (file) => {
  const formData = new FormData()
  formData.append('avatar', file)
  return request({
    method: 'post',
    url: '/user/avatar',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取用户列表（分页）
export const getUserList = (params) => {
  return request({
    method: 'get',
    url: '/user/list',
    params   // axios 会自动拼接到 URL
  })
}

// 关注或者取关
export const follow = (data) => {
  return request({
    method: 'post',
    url: '/user/follow',
    data: data
  })
}







// 点赞或者取消点赞
export const like = (data) => {
  return request({
    method: 'post',
    url: '/user/onLike',
    data: data
  })
}

// 收藏或者取消收藏
export const collect = (data) => {
  return request({
    method: 'post',
    url: '/user/onCollect',
    data: data
  })
}

// 支付
export const confirmPay = (id) => {
  return request({
    method: 'post',
    url: '/user/confirmPay',
    data: id
  })
}





// 获取银行或者二维码列表数据
export const getRechargeInfo = () => {
  return request({
    method: 'get',
    url: '/user/getRechargeInfo',
  })
}

// 从服务端获取充值二维码图片
export const getImage = (url) => {
  return request({
    method: 'get',
    url,
  })
}

// 上传充值截图
export const uploadRechargeScreenshot = (file) => {
  const formData = new FormData()
  formData.append('file', file)  // 注意参数名是 'file'，和服务端保持一致

  return request({
    method: 'post',
    url: '/user/uploadRechargeScreenshot',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交转账截图记录
export const submitRechargeInfo = (fileName) => {
  return request({
    method: 'post',
    url: '/user/submitRechargeInfo',
    data: { detailScreenshot: fileName }
  })
}

// 获取客服列表
export const getCustomList = () => {
  return request({
    method: 'get',
    url: '/user/getCustomList',
  })
}